/**
 * Labstep
 */

import { PostFilter } from 'labstep-web/services/postFilter';
import { PostFilterComparison } from 'labstep-web/services/postFilter/constants';

export const PostFilterProtocolValueOriginNull = new PostFilter([
  ['protocolValueOrigin', PostFilterComparison.null],
]);
